import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { requestUnits, requestUnitToken } from "../services/requests";
import Footer from "../../src/components/Footer";
import NavBar from "../components/NavBar";
import CryptoJS from "crypto-js";
import Buffer from "buffer";

function NotesLogin() {
  const [token, setToken] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setToken(value);
  };

  const encryptName = (name) => {
    const encoded = btoa(name); // Codifica para base64
    return encoded;
  };

  const handleLogin = async () => {
    if (token.length < 8 || token.length > 8) {
      setShowAlert(true);
      return;
    }
  
    const requestLog = await requestUnitToken({ token });
    // if (!requestLog.error) {
    // } else {
    //   setShowAlert(true);
    // }

    if (!requestLog.error) {
      navigate(`/notificacoes/${encryptName(requestLog?.nome)}`);
    } else {
      setShowAlert(true);
    }
    /* 
		navigate(`/notificacoes/${encryptName('CER Ilha do Governador')}`); */
  };

  useEffect(() => {}, []);

  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <div className="text-center flex-grow mt-10">
        <section>
          <div className="flex flex-col items-center mb-[200px]  sm:mb-[100px] mt-20 mx-auto md:h-full w-[80%] sm:w-[100%] lg:py-0">
            <div className="md:w-full bg-white rounded-lg shadow border md:mt-0 sm:max-w-md xl:p-0">
              <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 className="text-2xl text-[#13335A] font-bold leading-tight tracking-tight text-slate-700  md:text-3xl">
                  Insira o Token da sua Unidade
                </h1>
                <p className="text-md font-semibold leading-tight tracking-tight text-slate-500  ">
                  ou escaneie o QR code localizado na unidade
                </p>
                <form className="space-y-4 md:space-y-6" onSubmit={handleLogin}>
                  <div className="relative">
                    <input
                      ref={inputRef}
                      type="text"
                      placeholder="Token"
                      className="bg-gray-50 border border-gray-300 text-gray-700 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 rounded-md" // Adicionado rounded-md
                      value={token}
                      onChange={handleInputChange}
                      required
                    />
                    {showAlert && (
                      <p className="text-red-500 mt-5 text-left font-roboto">
                        Token Inválido
                      </p>
                    )}
                    <button
                      type="button"
                      onClick={handleLogin}
                      disabled={!token.trim()} // Botão só habilita se token não estiver vazio
                      className={`focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm w-40 px-5 py-2.5 me-2 mb-2 mt-10 focus:outline-none transition-all duration-200 border
    ${
      token.trim()
        ? "bg-[#13335A] text-white hover:bg-[#0078B5] border-transparent"
        : "bg-white text-gray-300 border-gray-300 cursor-not-allowed"
    }`}
                    >
                      {token.length < 7 ? "Enviar" : "Enviar"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default NotesLogin;